module.exports = __webpack_public_path__ + "static/m-j-freitas-5edc84e2ba3c05100beee8555242ea67.png";